@if (cityContent$ | async) {
<ng-container #container></ng-container>
}